import { Link as RouterLink, useLocation, type LinkProps } from "react-router-dom";
import { isEnPath, localize } from "@/lib/locale";

// react-router Link 와 같은 사용법. 영문 페이지(/en/...)에 있으면 내부 주소에 /en 을 자동으로 붙여
// 영문 페이지끼리 서로 연결되게 합니다. (예: to="/about" → 영문 페이지에서는 /en/about)
export default function Link({ to, ...rest }: LinkProps) {
  const { pathname } = useLocation();
  return <RouterLink to={typeof to === "string" ? localize(to, isEnPath(pathname)) : to} {...rest} />;
}
